import {useAuth} from "../../../../context/authContext";
import {Button, Dropdown} from "antd";
import type {MenuProps, TableColumnsType} from "antd";
import {ScheduleItem, ScheduleTableServiceProps} from "../../../../types/schedule";
import {CalendarOutlined, ClockCircleOutlined, DeleteOutlined, EditOutlined, MoreOutlined, UserOutlined} from "@ant-design/icons";

const useScheduleTableService = ({scheduleController}: ScheduleTableServiceProps) => {
  const {canManageContent} = useAuth()

  const getAdminMenu = (record: ScheduleItem): MenuProps["items"] => [
    {key: "edit", icon: <EditOutlined/>, label: "Редагувати", onClick: () => scheduleController.editButtonHandler(record)},
    {key: "delete", danger: true, icon: <DeleteOutlined/>, label: "Видалити", onClick: () => scheduleController.confirmDeleteRecord(record.$id || "")},
  ]

  const columns: TableColumnsType<ScheduleItem> = [
    {
      title: "Лікар",
      key: "doctor",
      width: 250,
      render: (_, record) => <div className="schedule-doctor">
        <span className="schedule-doctor__icon"><UserOutlined/></span>
        <span className="schedule-doctor__name">{typeof record.staff === "object" ? record.staff.fullName : "—"}</span>
      </div>,
    },
    {
      title: "Посада",
      key: "position",
      width: 260,
      render: (_, record) => <span className="schedule-position">{typeof record.staff === "object" ? record.staff.position : "—"}</span>,
    },
    {
      title: "Дні прийому",
      dataIndex: "availableDays",
      width: 300,
      render: (days: string[]) => <div className="schedule-days"><CalendarOutlined/>{days?.map((day) => <span key={day}>{day}</span>)}</div>,
    },
    {
      title: "Години",
      dataIndex: "availableTime",
      width: 150,
      render: (time: string) => <span className="schedule-time"><ClockCircleOutlined/>{time || "—"}</span>,
    },
  ]

  if (canManageContent) {
    columns.push({
      title: "",
      key: "actions",
      width: 64,
      align: "center",
      render: (_, record) => <Dropdown menu={{items: getAdminMenu(record)}} trigger={["click"]}>
        <Button type="text" shape="circle" icon={<MoreOutlined/>} aria-label="Керування записом розкладу"/>
      </Dropdown>,
    })
  }

  return {columns}
}

export default useScheduleTableService
